import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.$inner = this.$('inner')[0]
    }    

    setContent(args) {
        if(this.title == args.title) return;

        this.title = args.title

        this.$inner.children[0].innerText = args.title[0]
        this.$inner.children[1].innerText = args.title[1]

        this.$inner.href = args.href

        // Retoggle animation
        this.$inner.style.animationName = 'none';
        this.$inner.offsetHeight; /* trigger reflow */
        this.$inner.style.animationName = html.getAttribute('data-scroll-direction') == 'up' ? 'projectListTitleAppear' : 'projectListTitleAppearReverse';
    }
}
